<template>
    <div>Структура подразделения</div>
</template>

<script>
export default  {
    name: 'deps-structure-view'
}
</script>